import { useResponsive } from '@sg/garnish';

import { useWindowWidthAtLeast } from '../../../../../hooks/useWindowWidthAtLeast';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Account menu icons show on phones and on wide layouts with room for them. Narrower wide
 * layouts drop them so the sidebar labels fit.
 */
export const useShouldShowAccountMenuIcons = () => {
  const { currentBreakpoint } = useResponsive();
  const hasRoomForSidebarIcons = useWindowWidthAtLeast({ minWidth: SIDEBAR_ICONS_MIN_WINDOW_WIDTH }); // prettier-ignore

  return currentBreakpoint.isXS || hasRoomForSidebarIcons;
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SIDEBAR_ICONS_MIN_WINDOW_WIDTH = 900;
